import React from 'react';
import PropTypes from 'prop-types';

import MaterialCommunityIcons from './Icons/MaterialCommunityIcons';
import FontAwesomeIcons from './Icons/FontAwesomeIcons';
import { getColorProcess, toHexadecimal } from './Utilitarios';

export const DEFAULT_ICON_SIZE = 30;

const IconRequest = ({ process, state, image, off, size }) => {
  switch (process) {
    case 0:
    case 1:
    case 2:
    case 3:
      return (
        <MaterialCommunityIcons
          name={image}
          color={getColorProcess(off ? 4 : process, state ?? '')}
          size={size}
        />
      );
    default:
      return (
        <FontAwesomeIcons
          name={image}
          color={getColorProcess(off ? 4 : process, state ?? '')}
          size={size}
        />
      );
  }
};

IconRequest.propTypes = {
  process: PropTypes.number.isRequired,
  state: PropTypes.string,
  image: PropTypes.string,
  off: PropTypes.bool,
  size: PropTypes.number,
};

IconRequest.defaultProps = {
  size: DEFAULT_ICON_SIZE,
};

export default IconRequest;
